import axios from "axios";
import NProgress from 'nprogress';
import 'nprogress/nprogress.css';

const request = axios.create({
  //baseURL: "http://localhost:8083",
  baseURL: "http://www.zkzhixin.cn",
  timeout: 20000,
  headers: { "Content-Type": "application/json" },
  withCredentials: true, 
});
request.interceptors.request.use(
  function (config) {
    NProgress.start() // 设置加载进度条(开始..)
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

// 添加响应拦截器
request.interceptors.response.use(
  function (response) {
    NProgress.done() // 设置加载进度条(结束..)
    return response;
  },
  function (error) {
    return Promise.reject(error);
  }
);

export default request;
